export default class PredictiveSearch {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.searchForm = this.element.querySelector('#search-page-form');
    this.searchWrapperID = '#top-search-wrapper';
    this.searchWrapper = this.element.querySelector(this.searchWrapperID);
    this.searchIcons = this.element.querySelectorAll('.search-show');
    this.searchClear = this.element.querySelectorAll('.search-clear');
    this.searchInput = this.element.querySelector('#search_text');
    this.SearchSubmitBtn = this.element.querySelector('#search_submit');
    this.searchClearBtn = this.element.querySelector('#search-bar--clear');
    this.loadingIcon = this.element.querySelector('.predictive-loading');
    this.searchSummary = this.element.querySelector('.search-summary');
    this.searchResultsPanel = this.element.querySelector('.search-results-panel');
    this.searchResultsStatus = this.element.querySelector('.search-status');
    this.searchElement = this.element.querySelector('.top-search');
    this.searchElement ? this.animTime = parseFloat(getComputedStyle(this.searchElement).transitionDuration) * 1000 : 0;

    this.searchChangeTimer = null;
    this.searchToggler = null;
    this.lastFocus = document.activeElement;
    this.searchResultsNum = 0;
    this.searchHasResults = false;

    this.isSearchPredictive = false;
    this.showPrices = false;
    this.showVendor = false;
    this.initialLoad = true;

    if (this.searchInput) {
      this.isSearchPredictive = this.searchInput.classList.contains('is-predictive');
      this.showPrices = (this.searchInput.dataset.showPrices == 'true');
      this.showVendor = (this.searchInput.dataset.showVendor == 'true');
      this.loadSearch();
    }
  }

    loadSearch = () => {
      const self = this;

      for (const icon of this.searchIcons) {
        icon.addEventListener('click', this.searchOpen);
      }

      for (const clear of this.searchClear) {
        clear.addEventListener('click', this.searchClose);
        clear.addEventListener('keyup', function(e) {
          if (e.keyCode === 13) {
            self.searchClose();
          }
        });
      }

      this.searchForm.addEventListener('submit', this.searchSubmit);
      this.searchWrapper.addEventListener('click', this.backgroundSearchClose);
      this.searchInput.addEventListener('keyup', this.searchChanged);

      document.addEventListener('click', function(e) {
        if(e.target && e.target.classList.contains('search-results__meta-clear')) {
          self.searchResultsNum = 0;
          self.searchHasResults = false;
          self.searchResultsPanel.innerHTML = '';
          self.searchInput.value = '';
          self.searchInput.focus();
          self.searchWrapper.classList.remove('has-results');
        }
      });

      // forcing WOW animations (wow.js bug)
      var scrollable = $(this.searchResultsPanel);
      scrollable.on('scroll.wow', function(){
        scrollable.find('.wow:not(.animated)').removeAttr('style').addClass('animated').css('visibility', 'visible');
      });
    }

    searchSubmit = (e) => {
      // Search has been submitted, by a keypress or clicking the icon.
      // We need to send the search term so that the search page's
      // results match the predictive results. E.g. appending '*' so
      // the search page does a 'starts with' search.
      e.preventDefault();
      window.location.href = this.getSearchPageUrlWithQuery();
    }

    searchOpen = (e) => {
      e.preventDefault();
      this.lockScrolling();
      this.searchToggler = $(e.target).closest('.search-show');

      this.searchToggler.attr('aria-expanded', 'true');
      this.searchWrapper.classList.add('expanded');
      this.searchInput.setAttribute('tabindex', '0');
      this.SearchSubmitBtn.setAttribute('tabindex', '0');
      this.searchClearBtn.setAttribute('tabindex', '0');
      this.searchInput.setAttribute('aria-hidden', 'false');
      this.SearchSubmitBtn.setAttribute('aria-hidden', 'false');
      this.searchClearBtn.setAttribute('aria-hidden', 'false');
      this.moveCursorToEnd(this.searchInput);
      this.lastFocus = document.activeElement;
      setTimeout(this.trapFocus, this.animTime);
      return false;
    }

    searchClose = (e) => {
      this.unlockScrolling();

      this.searchToggler.attr('aria-expanded', 'false');
      this.searchWrapper.classList.remove('expanded');
      this.searchWrapper.classList.add('closing');
      this.searchInput.setAttribute('tabindex', '-1');
      this.SearchSubmitBtn.setAttribute('tabindex', '-1');
      this.searchClearBtn.setAttribute('tabindex', '-1');
      this.searchInput.setAttribute('aria-hidden', 'false');
      this.SearchSubmitBtn.setAttribute('aria-hidden', 'false');
      this.searchClearBtn.setAttribute('aria-hidden', 'false');
      this.searchInput.blur();
      setTimeout(() => {
        this.searchWrapper.classList.remove('closing');
      }, this.animTime);
      return false;
    }

    handleLastInputKeydown = (e, firstInput) => {
      // Redirect last tab to first input
      if (e.keyCode === 9 && !e.shiftKey) {
        e.preventDefault();
        firstInput.focus();
      }
    }

    handleFirstInputKeydown = (e, lastInput) => {
      // First input is the close icon, so allow closing via enter key.
      if (e.keyCode == 13) {
        e.preventDefault();
        self.hide();
        this.lastFocus.focus();
      }

      // Redirect first shift+tab to last input
      if (e.keyCode === 9 && e.shiftKey) {
        e.preventDefault();
        lastInput.focus();
      }
    }

    resetCloseBtnKeydown = (e, nextElement) => {
      if (e.keyCode === 9 && !e.shiftKey) {
        nextElement.focus();
      }
    }

    trapFocus = () => {
      var inputs = this.element.querySelectorAll(`${this.searchWrapperID} input:not([type=hidden]), ${this.searchWrapperID} button, ${this.searchWrapperID} a, ${this.searchWrapperID} .search-clear`);
      var inputsArr = Array.from(inputs);
      var closeBtnIndex = inputsArr.indexOf(inputsArr.find(el => el.id == 'search-bar--clear'));
      var firstInput = inputs[0];
      var lastInput = inputs[inputs.length-1];
      var self = this;

      // If search box is there, focus on input
      if (this.element.querySelector(this.searchWrapperID) && this.initialLoad) {
        this.element.querySelector('#search_text').focus();
      }

      // If the last input is not the close btn then reset the keydown handler
      // n.b. this is a workaround as could not get removeEventListener to work
      if (lastInput.id != 'search-bar--clear') {
        this.searchClearBtn.addEventListener('keydown', function (e) {
          self.resetCloseBtnKeydown(e, inputs[closeBtnIndex + 1]);
        })
      }

      lastInput.addEventListener('keydown', function (e) {
        self.handleLastInputKeydown(e, firstInput);
      });

      firstInput.addEventListener('keydown', function (e) {
        self.handleFirstInputKeydown(e, lastInput);
      });

      this.initialLoad = false;
    }

    backgroundSearchClose = (e) => {
      if(e.target !== e.currentTarget) return;
      this.searchClose();
    }

    moveCursorToEnd = (el) => {
      el.focus();
      if (typeof el.selectionStart == "number") {
        el.selectionStart = el.selectionEnd = el.value.length;
      } else if (typeof el.createTextRange != "undefined") {
        var range = el.createTextRange();
        range.collapse(false);
        range.select();
      }
    }

    searchChanged = (e) => {
      var inputText = e.target.value;

      if(this.isSearchPredictive) {
        if(inputText > '') {
          if (this.searchChangeTimer) {
            clearTimeout(this.searchChangeTimer);
          }
          this.searchChangeTimer = setTimeout(() => {
            this.performSearch();
            this.searchChangeTimer = null;
          }, 600);
        }
        else {
          this.searchResultsNum = 0;
          this.searchHasResults = false;
          this.searchWrapper.classList.remove('has-results');
          this.searchResultsPanel.innerHTML = '';
        }
      }
    }

    hideLoading = () => {
      this.loadingIcon.classList.add('hide');
    }

    showLoading = () => {
      this.displayResults(false);
      this.loadingIcon.classList.remove('hide');
    }

    getSearchQuery = () => {
      return `/search/suggest.json?q=${this.searchInput.value}&resources[limit]=3&resources[limit_scope]=each`;
    }

    getSearchPageUrlWithQuery = () => {
      return `/search?q=${encodeURIComponent(this.searchInput.value)}*`;
    }

    getMinImageUrl = (originalUrl, size = "300") => {
      return originalUrl.replace(/((?:.+\/.+)+\/)(.?.+)+\.(.+)/, `$1$2_${size}x.$3`);
    }

    lockScrolling = () => {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
    }

    unlockScrolling = () => {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    performSearch = async () => {
      this.showLoading();
      this.searchHasResults = false;
      this.searchResultsNum = 0;
      this.searchWrapper.classList.remove('has-results');

      var searchUrlWithQuery = this.getSearchQuery();

      let data;
      try {
        const response = await fetch(searchUrlWithQuery);

        if (!response.ok) {
          console.error("Search failed", response);
          window.location.href = this.getSearchPageUrlWithQuery();
          return;
        }
        data = await response.json();
      }
      catch (e) {
        console.error("Search failed", e);
        // We'll redirect the user to /search page when ajax search fails.
        window.location.href = this.getSearchPageUrlWithQuery();
      }

      const resultGroups = new Map();

      // Loop over groups e.g. Products / Pages / Articles / Collections
      Object.keys(data.resources.results).forEach((resultType) => {
        let group = resultGroups.get(resultType);
        let result = data.resources.results[resultType];

        if (!group) {
          group = {
            name: {
              'suggestions': this.theme.translations.suggestions,
              'articles': this.theme.translations.articles,
              'pages': this.theme.translations.pages,
              'products': this.theme.translations.products,
              'collections': this.theme.translations.collections,
            }[resultType],
            results: [],
          };
          resultGroups.set(resultType, group);
        }

        // Format price.
        let resultWithPrice = result.map(item => {
          var temp = Object.assign({}, item);
          if(temp.price) {
            temp.price = this.theme.formatMoney(temp.price);
            temp.price_max_fromatted = this.theme.formatMoney(temp.price_max);
          }
          return temp;
        });

        group.results = resultWithPrice;

        if(group.results && group.results.length > 0) {
          this.searchResultsNum += result.length;
          this.searchHasResults = true;
        }
      });

      if (!this.searchHasResults && this.searchInput.value > '') {
        // UX: Hide the empty-state drop-down when there are no product suggestions
        // that match the query. The lack of feedback from predictive search should
        // encourage customers to continue their search from the results page.

        // Display 'no results found for XYZ' text.
        // this.searchSummary.innerHTML = this.theme.translations.no_results_html.replace('{{ terms }}', this.searchInput.value);

        // Display no feedback.
        this.searchSummary.innerHTML = '';
      }

      const searchGroups = Array.from(resultGroups.values());
      this.hideLoading();
      this.displayResults(searchGroups, this.trapFocus);
    }

    displayResults = (results, searchTrapFocus) => {

      if(!results || this.searchInput.value == '') {
        this.searchResultsPanel.innerHTML = '';
        this.searchWrapper.classList.remove('has-results');
        return;
      }

      let self = this;
      let resultsHtml = '';
      const soldOut = this.theme.translations.soldOut;
      let searchPageUrlWithQuery = this.getSearchPageUrlWithQuery();
      const resultPluralize = this.searchResultsNum == 1 ? this.theme.translations.search_result : this.theme.translations.search_result_plural;
      const noneFound = this.searchResultsNum == 0 ? this.theme.translations.none_found : "";

      if(this.searchInput.value > '' || this.searchResultsNum > 0) {
        resultsHtml = resultsHtml.concat(`<div class="search-results__meta top${ noneFound ? ' no-results' : '' }">`);
      }

      resultsHtml = resultsHtml.concat(`
          <div class="search-results__status ${ noneFound ? '' : 'sr-only' }" role="status">${noneFound} ${resultPluralize} ${this.theme.translations.search_found}.</div>
      `);

      if(this.searchInput.value > '' || this.searchResultsNum > 0) {
        resultsHtml = resultsHtml.concat(`</div>`);
      }

      Object.keys(results).forEach(function (groupKey) {
        const group = results[groupKey];
        if(group.name == undefined) {
          // Suggestions group has name property set to undefined
          group.name = self.theme.translations.suggestions;
        }
        const groupResults = group.results;

        if(groupResults.length > 0) {
          resultsHtml = resultsHtml.concat(`<div class="predictive-search-group">`);
          resultsHtml = resultsHtml.concat(`  <h2 class="type-subheading type-subheading--1">${group.name}</h2>`);
          resultsHtml = resultsHtml.concat(`  <div class="search--result-group ${group.name.toLowerCase()}-results">`);

          if(group.name == 'Products') {
            Object.keys(groupResults).forEach(function (resultKey, index) {
              const result = groupResults[resultKey];

              resultsHtml = resultsHtml.concat(`<article class="wow fadeInUp${index != 0 ? ` delay-${index}` : ''}">`);

              if(result.featured_image && result.featured_image.url > '') {
                const minImageUrl = self.getMinImageUrl(result.featured_image.url);
                resultsHtml = resultsHtml.concat(`<div>`);
                resultsHtml = resultsHtml.concat(`<a href="${result.url}"><img src="${minImageUrl}" alt="${result.featured_image.alt}" /></a>`);
                resultsHtml = resultsHtml.concat(`</div>`);
              }

              resultsHtml = resultsHtml.concat(`<div>`);

              if(self.showVendor && result.vendor) {
                resultsHtml = resultsHtml.concat(`<div class="search-vendor">${result.vendor}</div>`);
              }

              resultsHtml = resultsHtml.concat(` <h5><a href="${result.url}">${result.title}</a></h5>`);

              if(!result.available) {
                resultsHtml = resultsHtml.concat(`<div>${soldOut}</div>`);
              } else {
                if(self.showPrices && result.price) {
                  if (result.price_max != result.price_min) {
                    resultsHtml = resultsHtml.concat(`<span class="compare-at-price"><span class="money">${result.price_max_fromatted}</span></span>`);
                  }
                  resultsHtml = resultsHtml.concat(` <div class="search-price">${result.price}</div>`);
                }
              }

              resultsHtml = resultsHtml.concat(`</div></article>`);
            });
          } else if(group.name == 'Collections') {
            Object.keys(groupResults).forEach(function (resultKey, index) {
              const result = groupResults[resultKey];

              resultsHtml = resultsHtml.concat(`<article class="wow fadeInUp${index != 0 ? ` delay-${index}` : ''}">`);

              if(result.featured_image && result.featured_image.url > '') {
                const minImageUrl = self.getMinImageUrl(result.featured_image.url);
                resultsHtml = resultsHtml.concat(`<div>`);
                resultsHtml = resultsHtml.concat(`<a href="${result.url}"><img src="${minImageUrl}" alt="${result.featured_image.alt}" /></a>`);
                resultsHtml = resultsHtml.concat(`</div>`);
              }

              resultsHtml = resultsHtml.concat(`<div>`);

              resultsHtml = resultsHtml.concat(` <h5><a href="${result.url}">${result.title}</a></h5>`);

              resultsHtml = resultsHtml.concat(`</div></article>`);
            });
          } else {
            Object.keys(groupResults).forEach(function (resultKey, index) {
              const result = groupResults[resultKey];
              let infoColClass = 'col-12';

              resultsHtml = resultsHtml.concat(`<article class="row wow fadeInUp${index != 0 ? ` delay-${index}` : ''}">`);

              if(result.featured_image && result.featured_image.url > '') {
                const minImageUrl = self.getMinImageUrl(result.featured_image.url);
                resultsHtml = resultsHtml.concat(`<div class="col-3">`);
                resultsHtml = resultsHtml.concat(`<a href="${result.url}"><img src="${minImageUrl}" alt="${result.featured_image.alt}" /></a>`);
                resultsHtml = resultsHtml.concat(`</div>`);
                infoColClass = 'col-9';
              }

              resultsHtml = resultsHtml.concat(`<div class="${infoColClass}">`);

              resultsHtml = resultsHtml.concat(` <h5><a href="${result.url}">${result.title ? result.title : result.styled_text}</a></h5>`);

              resultsHtml = resultsHtml.concat(`</div></article>`);
              resultsHtml = resultsHtml.concat(`<span class="search-result-separator"><hr /></span>`);
            });
          }

          resultsHtml = resultsHtml.concat(`  </div>`);
          resultsHtml = resultsHtml.concat(`</div>`);
        }
      });

      if(this.searchResultsNum > 0) {
        resultsHtml = resultsHtml.concat(`
                <div class="search-results__meta bottom">
                  <div class="search-results__meta-view-all"><a href="${searchPageUrlWithQuery}" class="btn">${this.theme.translations.view_all}</a></div>
                </div>
            `);
      }

      if(this.searchInput.value > '') {
        this.searchWrapper.classList.add('has-results');
      }
      else {
        this.searchWrapper.classList.remove('has-results');
      }

      this.searchResultsPanel.innerHTML = resultsHtml;

      searchTrapFocus();
    }
}
